/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/ban-ts-comment */
export const useAuth = () => {
  const loginObject = localStorage.getItem('login');

  // @ts-ignore
  return JSON.parse(loginObject);
};
